import { FancyMultiSelect, type FancySelectItem } from '@/components/ui/fancy-multi-select';
import { cn } from '@/lib/utils';
import { useMemo, type JSX } from 'react';

interface ImageSubjectFilterProps {
    id: string;
    className?: string;
    subjectOptions: string[];
    selectedSubjects: string[];
    onSelectedSubjectsChange: (subjects: string[]) => void;
    disabledSubjects: string[];
    onToggleSubjectEnabled: (subject: string) => void;
    disabled?: boolean;
}

export function ImageSubjectFilter({
    id,
    className,
    subjectOptions,
    selectedSubjects,
    onSelectedSubjectsChange,
    disabledSubjects,
    onToggleSubjectEnabled,
    disabled = false,
}: Readonly<ImageSubjectFilterProps>): JSX.Element {
    const items = useMemo<FancySelectItem[]>(() => subjectOptions.map(subject => ({ value: subject, label: subject })), [subjectOptions]);

    return (
        <div
            id={id}
            className={cn('w-full min-w-0', className, disabled && 'pointer-events-none opacity-50')}
        >
            <FancyMultiSelect
                multiple
                items={items}
                selected={selectedSubjects}
                onValueChange={onSelectedSubjectsChange}
                inactiveValues={disabledSubjects}
                onToggleValue={onToggleSubjectEnabled}
                placeholder="Select subjects..."
            />
        </div>
    );
}
